window.isFetchingLocation = window.isFetchingLocation || false;
window.currencyArabicMap = window.currencyArabicMap || {
  QAR: 'ريال قطري',
  SAR: 'ريال سعودي',
  AED: 'درهم إماراتي',
  INR: 'روبية هندية',
  KWD: 'دينار كويتي',
  OMR: 'ريال عماني',
  BHD: 'دينار بحريني',
  JOD: 'دينار أردني',
  EGP: 'جنيه مصري',
  LBP: 'ليرة لبنانية',
  GBP: 'جنيه إسترليني',
  USD: 'دولار أمريكي',
  CAD: 'دولار كندي',
  EUR: 'يورو, دولار',
  AUD: 'أسترالي',
  NZD: 'دولار نيوزيلندي',
  PKR: 'روبية باكستانية',
  CNY: 'يوان صيني',
  PHP: 'بيزو فلبيني',
  BDT: 'تاكا بنغلاديشية',
  MYR: 'رينجيت ماليزي',
  LKR: 'روبية سريلانكية',
};

window.countryCodeToCurrency = window.countryCodeToCurrency || {
  AD: 'EUR',
  AE: 'AED',
  AF: 'AFN',
  AG: 'XCD',
  AI: 'XCD',
  AL: 'ALL',
  AM: 'AMD',
  AO: 'AOA',
  AQ: 'AQD',
  AR: 'ARS',
  AS: 'USD',
  AT: 'EUR',
  AU: 'AUD',
  AW: 'AWG',
  AX: 'EUR',
  AZ: 'AZN',
  BA: 'BAM',
  BB: 'BBD',
  BD: 'BDT',
  BE: 'EUR',
  BF: 'XOF',
  BG: 'BGN',
  BH: 'BHD',
  BI: 'BIF',
  BJ: 'XOF',
  BL: 'EUR',
  BM: 'BMD',
  BN: 'BND',
  BO: 'BOB',
  BQ: 'USD',
  BR: 'BRL',
  BS: 'BSD',
  BT: 'INR',
  BV: 'NOK',
  BW: 'BWP',
  BY: 'BYN',
  BZ: 'BZD',
  CA: 'CAD',
  CC: 'AUD',
  CD: 'CDF',
  CF: 'XAF',
  CG: 'XAF',
  CH: 'CHF',
  CI: 'XOF',
  CK: 'NZD',
  CL: 'CLP',
  CM: 'XAF',
  CN: 'CNY',
  CO: 'COP',
  CR: 'CRC',
  CU: 'CUP',
  CV: 'CVE',
  CW: 'ANG',
  CX: 'AUD',
  CY: 'EUR',
  CZ: 'CZK',
  DE: 'EUR',
  DJ: 'DJF',
  DK: 'DKK',
  DM: 'XCD',
  DO: 'DOP',
  DZ: 'DZD',
  EC: 'USD',
  EE: 'EUR',
  EG: 'EGP',
  EH: 'MAD',
  ER: 'ERN',
  ES: 'EUR',
  ET: 'ETB',
  FI: 'EUR',
  FJ: 'FJD',
  FK: 'FKP',
  FM: 'USD',
  FO: 'DKK',
  FR: 'EUR',
  GA: 'XAF',
  GB: 'GBP',
  GD: 'XCD',
  GE: 'GEL',
  GF: 'EUR',
  GG: 'GGP',
  GH: 'GHS',
  GI: 'GIP',
  GL: 'DKK',
  GM: 'GMD',
  GN: 'GNF',
  GP: 'EUR',
  GQ: 'XAF',
  GR: 'EUR',
  GS: 'GBP',
  GT: 'GTQ',
  GU: 'USD',
  GW: 'XOF',
  GY: 'GYD',
  HK: 'HKD',
  HM: 'AUD',
  HN: 'HNL',
  HR: 'HRK',
  HT: 'HTG',
  HU: 'HUF',
  ID: 'IDR',
  IE: 'EUR',
  IL: 'ILS',
  IM: 'GBP',
  IN: 'INR',
  IO: 'USD',
  IQ: 'IQD',
  IR: 'IRR',
  IS: 'ISK',
  IT: 'EUR',
  JE: 'GBP',
  JM: 'JMD',
  JO: 'JOD',
  JP: 'JPY',
  KE: 'KES',
  KG: 'KGS',
  KH: 'KHR',
  KI: 'AUD',
  KM: 'KMF',
  KN: 'XCD',
  KP: 'KPW',
  KR: 'KRW',
  KW: 'KWD',
  KY: 'KYD',
  KZ: 'KZT',
  LA: 'LAK',
  LB: 'LBP',
  LC: 'XCD',
  LI: 'CHF',
  LK: 'LKR',
  LR: 'LRD',
  LS: 'LSL',
  LT: 'EUR',
  LU: 'EUR',
  LV: 'EUR',
  LY: 'LYD',
  MA: 'MAD',
  MC: 'EUR',
  MD: 'MDL',
  ME: 'EUR',
  MF: 'EUR',
  MG: 'MGA',
  MH: 'USD',
  MK: 'MKD',
  ML: 'XOF',
  MM: 'MMK',
  MN: 'MNT',
  MO: 'MOP',
  MP: 'USD',
  MQ: 'EUR',
  MR: 'MRO',
  MS: 'XCD',
  MT: 'EUR',
  MU: 'MUR',
  MV: 'MVR',
  MW: 'MWK',
  MX: 'MXN',
  MY: 'MYR',
  MZ: 'MZN',
  NA: 'NAD',
  NC: 'XPF',
  NE: 'XOF',
  NF: 'AUD',
  NG: 'NGN',
  NI: 'NIO',
  NL: 'EUR',
  NO: 'NOK',
  NP: 'NPR',
  NR: 'AUD',
  NU: 'NZD',
  NZ: 'NZD',
  OM: 'OMR',
  PA: 'PAB',
  PE: 'PEN',
  PF: 'XPF',
  PG: 'PGK',
  PH: 'PHP',
  PK: 'PKR',
  PL: 'PLN',
  PM: 'EUR',
  PN: 'NZD',
  PR: 'USD',
  PS: 'JOD',
  PT: 'EUR',
  PW: 'USD',
  PY: 'PYG',
  QA: 'QAR',
  RE: 'EUR',
  RO: 'RON',
  RS: 'RSD',
  RU: 'RUB',
  RW: 'RWF',
  SA: 'SAR',
  SB: 'SBD',
  SC: 'SCR',
  SD: 'SDG',
  SE: 'SEK',
  SG: 'SGD',
  SH: 'SHP',
  SI: 'EUR',
  SJ: 'NOK',
  SK: 'EUR',
  SL: 'SLL',
  SM: 'EUR',
  SN: 'XOF',
  SO: 'SOS',
  SR: 'SRD',
  SS: 'SSP',
  ST: 'STD',
  SV: 'USD',
  SX: 'ANG',
  SY: 'SYP',
  SZ: 'SZL',
  TC: 'USD',
  TD: 'XAF',
  TF: 'EUR',
  TG: 'XOF',
  TH: 'THB',
  TJ: 'TJS',
  TK: 'NZD',
  TL: 'USD',
  TM: 'TMT',
  TN: 'TND',
  TO: 'TOP',
  TR: 'TRY',
  TT: 'TTD',
  TV: 'AUD',
  TW: 'TWD',
  TZ: 'TZS',
  UA: 'UAH',
  UG: 'UGX',
  UM: 'USD',
  US: 'USD',
  UY: 'UYU',
  UZ: 'UZS',
  VA: 'EUR',
  VC: 'XCD',
  VE: 'VEF',
  VG: 'USD',
  VI: 'USD',
  VN: 'VND',
  VU: 'VUV',
  WF: 'XPF',
  WS: 'EUR',
  YE: 'YER',
  YT: 'EUR',
  ZA: 'ZAR',
  ZM: 'ZMW',
  ZW: 'USD',
};

window.rates = window.rates || null;

function convertAmmount(amount, from, to, rates = rates) {
  if (!rates) return null;
  // Convert amount to number to ensure numeric operation
  const numericAmount = Number(amount);
  if (isNaN(numericAmount)) return amount;

  let convertedAmount = (numericAmount * rates[from]) / rates[to];
  // Check if result is a valid number
  return isNaN(convertedAmount) ? amount : convertedAmount.toFixed(2);
}

function handleCurrencyShow(element) {
  let currencySelector = element.closest('.currencySwitcherElement').querySelector('.optional_value_selector');
  if (currencySelector) {
    currencySelector.classList.toggle('optional_value_selector-flex');
  }
  element.classList.toggle('active');
}

function handleCurrencyhandle(element, currency, name) {
  let wrapper = element.closest('.currencySwitcherElement');
  let currencySelector = wrapper.querySelector('.optional_value_selector');
  let selectedValue = wrapper.querySelector('.selected_value');
  if (currencySelector) {
    currencySelector.classList.remove('optional_value_selector-flex');
  }
  if (selectedValue) {
    selectedValue.classList.toggle('active');
  }
  changePriceConvertion(`${SHOP_CURRENCY}`, currency);
}

async function fetchCurrencyRates() {
  if(rates) return rates;
  if (window.location.origin === 'http://127.0.0.1:9292') return;
  const response = await fetch('/services/javascripts/currencies.js');
  const responseText = await response.text();
  const conversionRates = JSON.parse(responseText.substring(responseText.search('rates: {') + 7, responseText.search('},') + 1));
  rates = conversionRates;
  return conversionRates;
}

function changePriceConvertion(baseCurrency, conversionCurrency) {
  // Array of class selectors to apply conversion to
  const priceElements = document.querySelectorAll("[data-price-to-convert]");
  priceElements.forEach((priceElement) => {
    let actualAmount = priceElement.getAttribute('data-price-to-convert');
    if (!actualAmount) return;
    // Convert if it's not the shop's base currency
    if (conversionCurrency !== `${SHOP_CURRENCY}`) {
      if (sessionStorage.currentCurrency) {
        actualAmount = actualAmount / 100;
      }
    }
    let convertedAmount = convertAmmount(actualAmount, baseCurrency, conversionCurrency, rates);
    // Format for shop's base currency
    if (convertedAmount && conversionCurrency === `${SHOP_CURRENCY}`) {
      convertedAmount = actualAmount / 100;
    }
    // Output text depending on store settings
    if (convertedAmount) {
      if (CURRENCY_CODE_ENABLED) {
        if (Shopify.locale === 'ar' && conversionCurrency === 'SAR') {
          const sarIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1124.14 1256.39" style="width: 1em; height: 1em; vertical-align: middle; margin-left: 4px;"><path fill="#231f20" d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z"></path><path fill="#231f20" d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z"></path></svg>';
          priceElement.innerHTML = `${convertedAmount} ${sarIcon}`;
        } else {
          priceElement.innerHTML = `<span class="currency-text">${conversionCurrency}</span> ${convertedAmount}`;
        }
      } else {
        priceElement.innerHTML = convertedAmount;
      }
      priceElement.classList.add('reveal');
      changeDropDownValue(conversionCurrency);
    }
  });
}

function initialCurrencyChange() {
  if (sessionStorage.currentCurrency) {
    (async () => {
      await fetchCurrencyRates();
      changePriceConvertion(`${SHOP_CURRENCY}`, sessionStorage.getItem('currentCurrency'));
    })()
  } else {
    if(window.isFetchingLocation) return;
    window.isFetchingLocation = true;
    fetch(`${window.location.origin}/browsing_context_suggestions.json`)
    .then(async (response) => {
      const data = await response.json();
      await fetchCurrencyRates();
      const currencyCodeGio = countryCodeToCurrency[`${data.detected_values.country.handle}`];
      sessionStorage.setItem('currentCurrency', currencyCodeGio);
      window.isFetchingLocation = false;
      changePriceConvertion(`${SHOP_CURRENCY}`, currencyCodeGio);
    })
    .catch((error) => {
      window.isFetchingLocation = false;
      console.error('Error fetching IP location:', error);
    });
  }
}

function changeDropDownValue(selectedValue = null) {
  if (!selectedValue) return;
  let allSelectorElement = document.querySelectorAll('.selected_value');
  sessionStorage.setItem('currentCurrency', selectedValue);
  if (allSelectorElement.length > 0) {
    allSelectorElement.forEach((selectorElement) => {
      selectorElement.textContent = Shopify.locale === 'ar' ? currencyArabicMap[selectedValue] : selectedValue;
    });
  }
}

if (window.innerWidth > 767) {
  document.addEventListener('click', function (event) {
    const optionalSelectors = [
      document.querySelector('.header-wrapper .currencySwitcherElement'),
      document.querySelector('.header-top-section .currencySwitcherElement')
    ];
    optionalSelectors.forEach(optionalSelector => {
      if (optionalSelector && !optionalSelector.contains(event.target)) {
        const removeElement = optionalSelector.querySelector('.optional_value_selector-flex');
        const removeActive = optionalSelector.querySelector('.selected_value.active');
        if (removeElement) {
          removeElement.classList.remove('optional_value_selector-flex');
        }
        if (removeActive) {
          removeActive.classList.remove('active');
        }
      }
    });
  });
}

initialCurrencyChange();
document.addEventListener('DOMContentLoaded', initialCurrencyChange);